export default __webpack_public_path__ + "static/media/wealth_map_head_01.02a6df5d.png";